import { render } from "./SettingsMenu.vue?vue&type=template&id=5030b23d&scoped=true"
import script from "./SettingsMenu.vue?vue&type=script&lang=ts"
export * from "./SettingsMenu.vue?vue&type=script&lang=ts"

import "./SettingsMenu.vue?vue&type=style&index=0&id=5030b23d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5030b23d"

export default script